<section class="my-3">
  <div class="row">
    <div class="col">
      <app-breadcrumb></app-breadcrumb>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <mdb-card cascade="true" narrower="true">
        <div class="view view-cascade eco-secondary narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center">
          <div>
            <button routerLink="/usuario-crear" mdbBtn color="white" outline="true" rounded="true" size="sm" type="button" class="px-2" mdbWavesEffect>
              <mdb-icon fas icon="plus" class="mt-0"></mdb-icon>
            </button>
          </div>
          <h3 class="white-text mx-3">Usuarios</h3>
          <div></div>
        </div>
        <div class="px-4">
          <div class="table-responsive">
            <table class="mb-0" mdbTable mdbTableScroll scrollX="true" hover="true">
              <tr>
                <th>Nombre</th>
                <th>Apellidos</th>
                <th>Usuario</th>
                <th *ngIf="isSuperAdmin">Proyecto</th>
                <th class="text-right">Acciones</th>
              </tr>
              <tr mdbTableCol *ngFor="let u of usuarios">
                <td>{{ u.nombre }}</td>
                <td>{{ u.apellidos }}</td>
                <td>{{ u.correo }}</td>
                <td *ngIf="isSuperAdmin">{{ u.proyecto}}</td>
                <td class="text-right">
                  <a routerLink="/usuario-editar/{{u._id}}"class="teal-text" mdbTooltip="Editar" placement="top">
                    <mdb-icon fas icon="pencil-alt" class="px-1"></mdb-icon>
                  </a>
                  <a class="red-text" mdbTooltip="Eliminar" placement="top" (click)="openModal(u._id, u.nombre)">
                    <mdb-icon fas icon="times" class="px-1"></mdb-icon>
                  </a>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <app-pagination dashboard="usuario" [total]="total" [limit]="limit" (changePage)="onChangePage($event)"></app-pagination>
      </mdb-card>
    </div>
  </div>
</section>